import { jsx as P } from "react/jsx-runtime";
import { lazy as U, Suspense as _ } from "react";
import { r as I } from "./PaymentEntryType-a687b583.mjs";
import { o as x } from "./PaymentMethod-f2ce08ce.mjs";
import { T as D } from "./PaymentMethodId-cbeb8fbc.mjs";
import { cmsApi as a } from "@commerce-webcomponents/sdk";
import { formatPrice as z, ConsoleLogger as O } from "@nextgen-web-framework/core";
const R = {
  Refund: "REFUND",
  Bonus: "BONUS",
  Renewal: "RENEWAL"
}, q = (e) => {
  const n = {};
  return e == null || e.forEach(
    (o) => {
      var r;
      return n[o == null ? void 0 : o.paymentMethodProviderId] = (r = o.paymentMethod) == null ? void 0 : r.type;
    }
  ), n;
}, Q = (e) => {
  let n = e;
  return e && (n = e.slice(-4).padStart(e.length, "*").replace(/(.{4})/g, "$1 ").trim()), n;
}, $ = (e) => {
  let n = !1;
  const o = /* @__PURE__ */ new Date(), r = /* @__PURE__ */ new Date();
  if (e) {
    const s = e.slice(0, 2), t = e.slice(2, 4);
    r.setFullYear(parseInt(`20${t}`), parseInt(s), 1), o > r && (n = !0);
  }
  return n;
}, F = (e) => Number.isNaN(e) ? 0 : Math.round(e * 100) / 100, X = () => "฿", Z = (e) => {
  let n;
  try {
    n = new URL(e);
  } catch {
    return !1;
  }
  return n.protocol === "http:" || n.protocol === "https:";
}, j = ({
  points: e,
  pointsRatio: n,
  currency: o
}) => `${z(e / n, o)} (${e.toLocaleString()})`;
function k(e, n) {
  return e.find((o) => {
    var r;
    return ((r = o == null ? void 0 : o.paymentMethod) == null ? void 0 : r.code) === n;
  });
}
function E(e) {
  return e ? (Array.isArray(e) ? e : [e]).map((o) => {
    var r;
    return `${o.paymentMethodProviderId}: ${(r = o.amount) == null ? void 0 : r.value}`;
  }) : void 0;
}
function b(e, n) {
  var u, m, d, p, g, h, A, C, N, M, w, S, T, v, B;
  const o = (u = e.entries) == null ? void 0 : u.find((l) => l.entryType == I.Initiate), r = (m = e.entries) == null ? void 0 : m.find((l) => l.entryType == I.Auth), s = (d = e.entries) == null ? void 0 : d.find((l) => l.entryType == I.Capture), t = ((p = s == null ? void 0 : s.payload) == null ? void 0 : p.cardNo) || ((g = r == null ? void 0 : r.payload) == null ? void 0 : g.cardNo) || ((h = o == null ? void 0 : o.payload) == null ? void 0 : h.cardNo), i = ((A = s == null ? void 0 : s.payload) == null ? void 0 : A.cardSchemeCode) || ((C = r == null ? void 0 : r.payload) == null ? void 0 : C.cardSchemeCode) || ((N = o == null ? void 0 : o.payload) == null ? void 0 : N.cardSchemeCode), c = parseInt(((M = r == null ? void 0 : r.payload) == null ? void 0 : M.installmentPeriod) || 0), f = ((w = r == null ? void 0 : r.payload) == null ? void 0 : w.interestRate) || 0;
  if (t && i)
    return {
      cardNo: t,
      cardSchemeCode: i,
      noOfInstallments: c,
      interestRate: f
    };
  {
    const l = ((S = o == null ? void 0 : o.payload) == null ? void 0 : S.cardId) || ((T = r == null ? void 0 : r.payload) == null ? void 0 : T.cardId);
    if (l) {
      const y = (B = (v = n == null ? void 0 : n.additionalInfo) == null ? void 0 : v.cardInfoList) == null ? void 0 : B.find((L) => L.id === l);
      return y ? {
        cardNo: y.cardNo,
        cardSchemeCode: y.cardSchemeCode,
        noOfInstallments: c,
        interestRate: f
      } : void 0;
    }
    return;
  }
}
function ee({ cards: e, selected: n }) {
  let o = {};
  return e && e.length > 0 && (e.forEach((r, s) => {
    var t;
    r.isDefault && (o = (t = e.splice(s, 1)) == null ? void 0 : t[0]);
  }), e.sort((r, s) => {
    var c, f, u, m;
    const t = +(r.id === n), i = +(s.id === n);
    if (t > i)
      return -1;
    if (t < i)
      return 1;
    {
      const d = Number($(r.panExpiry)), p = Number($(s.panExpiry));
      if (d > p)
        return 1;
      if (d < p)
        return -1;
      {
        const g = (c = r == null ? void 0 : r.metadata) != null && c.createdAt ? new Date((f = r == null ? void 0 : r.metadata) == null ? void 0 : f.createdAt) : /* @__PURE__ */ new Date(), h = (u = s == null ? void 0 : s.metadata) != null && u.createdAt ? new Date((m = s == null ? void 0 : s.metadata) == null ? void 0 : m.createdAt) : /* @__PURE__ */ new Date();
        return g > h ? -1 : 0;
      }
    }
  }), o != null && o.id && e.unshift(o)), [...e];
}
function re(e) {
  let n;
  const o = [], r = [];
  for (const s of e)
    s.paymentMethod.code === `${D.AmwayPoints}` ? n = s : s.paymentMethod.type === x.Internal ? o.push(s) : r.push(s);
  return {
    ampointOption: n,
    internalOptions: o,
    externalOptions: r
  };
}
function oe(e, n, o, r) {
  const s = r ?? q(n), t = e.filter((i) => s[i == null ? void 0 : i.paymentMethodProviderId] === x.Internal).reduce((i, c) => i + (c.amount ? c.amount.value : 0), 0);
  return F(o.value - t);
}
function ne(e, n) {
  return e == null ? void 0 : e.find(
    (o) => (o == null ? void 0 : o.paymentMethodProviderId) === (n == null ? void 0 : n.paymentMethodProviderId)
  );
}
function se(e) {
  e.filter((n) => {
    var o;
    return (o = n.paymentMethod) == null ? void 0 : o.isBankTransfer;
  });
}
const te = (e, n) => {
  const o = U(e);
  return (r) => /* @__PURE__ */ P(_, { fallback: n, children: /* @__PURE__ */ P(o, { ...r }) });
}, ie = (e) => {
  const n = e == null ? void 0 : e.filter((r) => (r == null ? void 0 : r.accountUsage) === R.Bonus), o = e == null ? void 0 : e.filter((r) => (r == null ? void 0 : r.accountUsage) === R.Refund);
  return { bonusAcct: n, refundAcct: o };
}, ce = async (e) => {
  if (e.length > 0) {
    const n = [];
    e.forEach((o) => n.push(`"${encodeURIComponent(o.bankId)}"`));
    try {
      const o = await a.fetchAllContent({
        uId: "bank_detail",
        params: [
          {
            key: "query",
            value: `{"bank_id":{"$in":[${n}]}}`
          }
        ]
      });
      return e.map((r) => {
        const s = o.find((t) => t.bank_id === r.bankId);
        return {
          ...r,
          bankName: (s == null ? void 0 : s.bank_name) ?? "",
          acctNoErrorMessage: s == null ? void 0 : s.bank_error_message
        };
      });
    } catch (o) {
      return O.error(o), [];
    }
  } else
    return [];
}, le = (e) => ({
  billingAddress1: (e == null ? void 0 : e.addrLineOne) ?? "",
  billingAddress2: (e == null ? void 0 : e.addrLineTwo) ?? "",
  billingCity: (e == null ? void 0 : e.city) ?? "",
  billingState: (e == null ? void 0 : e.state) ?? "",
  billingPostcode: (e == null ? void 0 : e.postalCode) ?? "",
  billingCountry: (e == null ? void 0 : e.country) ?? ""
}), fe = (e) => ({
  shippingAddress1: (e == null ? void 0 : e.addrLineOne) ?? "",
  shippingAddress2: (e == null ? void 0 : e.addrLineTwo) ?? "",
  shippingCity: (e == null ? void 0 : e.city) ?? "",
  shippingState: (e == null ? void 0 : e.state) ?? "",
  shippingPostcode: (e == null ? void 0 : e.postalCode) ?? "",
  shippingCountry: (e == null ? void 0 : e.country) ?? ""
});
export {
  ne as a,
  F as b,
  le as c,
  fe as d,
  Q as e,
  re as f,
  k as g,
  X as h,
  Z as i,
  R as j,
  ie as k,
  te as l,
  ce as m,
  b as n,
  $ as o,
  j as p,
  se as q,
  oe as r,
  ee as s,
  E as t
};
//# sourceMappingURL=Utils-4c1dc98f.mjs.map
